import {
  Card,
  Container,
  createTheme,
  type MantineThemeOverride,
  Paper,
  rem,
  Select,
} from '@mantine/core';

const CONTAINER_SIZES: Record<string, string> = {
  lg: rem('600px'),
  md: rem('500px'),
  sm: rem('400px'),
  xl: rem('1400px'),
  xs: rem('300px'),
  xxl: rem('1600px'),
  xxs: rem('200px'),
};

export const theme: MantineThemeOverride = createTheme({
  components: {
    Card: Card.extend({
      defaultProps: {
        [`p`]: 'xl',
        radius: 'var(--mantine-radius-default)',
        shadow: 'xl',
        withBorder: true,
      },
    }),

    /**
     * Put your mantine component override here
     */
    Container: Container.extend({
      vars: (_, { fluid, size }) => ({
        root: {
          '--container-size': fluid
            ? '100%'
            : size !== undefined && size in CONTAINER_SIZES
              ? CONTAINER_SIZES[size]
              : rem(size),
        },
      }),
    }),

    Notifications: {
      classNames: {
        notification: `before:hidden bg-[var(--mantine-color-dark-5)] [&_*]:text-white [&_*]:align-middle
          [&_button]:text-white [&_button]:align-middle [&_button]:hover:bg-white/20
          [&_.mantine-Notification-description_svg]:inline-block
          [&_.mantine-Notification-description_svg]:font-[150%]
          [&_.mantine-Notification-description_svg]:me-[.5em]`,
      },
    },

    Overlay: { classNames: { root: 'backdrop-blur-[3px]' } },

    Paper: Paper.extend({
      defaultProps: {
        [`p`]: 'md',
        radius: 'md',
        shadow: 'xl',
        withBorder: true,
      },
    }),
    Select: Select.extend({
      defaultProps: {
        checkIconPosition: 'right',
      },
    }),
  },
  fontFamily: '"Open Sans", sans-serif',
  fontSizes: {
    '2xl': rem('24px'),
    '3xl': rem('30px'),
    '4xl': rem('36px'),
    '5xl': rem('48px'),
    lg: rem('18px'),
    md: rem('16px'),
    sm: rem('14px'),
    xl: rem('20px'),
    xs: rem('12px'),
  },
  other: {
    style: 'mantine',
  },
  primaryColor: 'red',
  spacing: {
    '2xl': rem('28px'),
    '2xs': rem('8px'),
    '3xl': rem('32px'),
    '3xs': rem('4px'),
    lg: rem('20px'),
    md: rem('16px'),
    sm: rem('12px'),
    xl: rem('24px'),
    xs: rem('10px'),
  },
});
